"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var ReportProblem =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(ReportProblem, _BasicProviderApi);

  function ReportProblem() {
    (0, _classCallCheck2.default)(this, ReportProblem);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReportProblem).apply(this, arguments));
  }

  (0, _createClass2.default)(ReportProblem, [{
    key: "postReportProblem",
    value: function () {
      var _postReportProblem = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(data) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._callApi({
                  method: 'post',
                  path: "/report-problem",
                  payload: data,

                  /*errorData : {data},*/
                  errorName: 'ReportProblemError'
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function postReportProblem(_x) {
        return _postReportProblem.apply(this, arguments);
      }

      return postReportProblem;
    }()
  }, {
    key: "publishCard",
    value: function () {
      var _publishCard = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(data) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'post',
                  path: "/publish-card",
                  payload: data,

                  /*errorData : {data},*/
                  errorName: 'ReportProblemError'
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function publishCard(_x2) {
        return _publishCard.apply(this, arguments);
      }

      return publishCard;
    }()
  }]);
  return ReportProblem;
}(_basic_provider.default);

var _default = ReportProblem;
exports.default = _default;